import { useQuery } from "@tanstack/react-query"
import { useOrganizationsService } from "@/modules/organizations/hooks/use-organizations"
import {
  getDistinctSkills,
  type DistinctSkillsResponse,
} from "../infrastructure/candidate-service"

export const distinctSkillsKeys = {
  all: ["distinct-skills"] as const,
  byOrg: (orgId: string) => ["distinct-skills", orgId] as const,
}

export function useDistinctSkills() {
  const { currentOrganization } = useOrganizationsService()
  const organizationId = currentOrganization?.id

  return useQuery<DistinctSkillsResponse>({
    queryKey: distinctSkillsKeys.byOrg(organizationId ?? ""),
    queryFn: () => getDistinctSkills(organizationId!),
    enabled: !!organizationId,
  })
}
